;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ReactNode } from 'react'

import { cn } from '../../utils/cn'

/**
 * Stacks the children on top of each other so they occupy the same space.
 *
 * Uses grid rather than absolute positioning so each child will still take up space in the layout.
 *
 * Renders a `<span>` by default, but can be changed to a `<div>` with the `as` prop.
 */
export function LayeredStack({
  children,
  as = 'span',
  className,
}: {
  children: ReactNode
  as?: 'span' | 'div'
  className?: string
}) {
  const Element = as
  return (
    <Element
      className={cn(
        'grid items-center justify-items-center [grid-template-areas:"stack"] *:[grid-area:stack]',
        className,
      )}
    >
      {children}
    </Element>
  )
}
